<sh-page-header
    [title]="recordTitle$ | async"
    [contextItems]="recordContextItems$ | async"
    [actionItems]="recordActionItems$ | async"
    [primaryNavigationItems]="primaryNavigationItems"
    [secondaryNavigationItems]="secondaryNavigationItems"
></sh-page-header>

<sh-notification
    *ngIf="notification"
    [type]="notification.type"
    [icon]="notification.icon"
    [title]="notification.title"
    [message]="notification.message"
    [messageList]="notification.messageList"
></sh-notification>

<ng-container *ngIf="(record$ | async) as record">
    <sh-notification
        *ngIf="showIncompleteRepresentationNotification$ | async"
        [icon]="'info'"
        [type]="NotificationType.Update"
        [message]="'representations.no-browse' | translate"
    ></sh-notification>

    <sh-notification
        *ngIf="showTransferredNotification$ | async"
        [icon]="'info'"
        [type]="NotificationType.Update"
        [message]="'dossier-transfer.transferred-on' | translate : { date: record.metadata.Dynamic.DossierDefinitiveTransferDate | date: 'dd MMM yyyy'}"
    ></sh-notification>
</ng-container>

<nav class="sh-tab-navigation" *ngIf="(recordTabItems$ | async) as tabItems">
    <ng-container *ngFor="let tabItem of tabItems">
        <ng-container
            *ngTemplateOutlet="(shouldEnableNavigationItem(tabItem.route) | async) ? enabledNavigationItem : disabledNavigationItem; context: {tabItem: tabItem}"
        ></ng-container>
    </ng-container>
</nav>

<ng-template #enabledNavigationItem let-tabItem="tabItem">
    <a
        *ngIf="(record$ | async) as currentRecord"
        #rla="routerLinkActive"
        [routerLink]="tabItem.route"
        [state]="{ record: currentRecord }"
        class="sh-tab-navigation__item"
        routerLinkActive="-sh-is-active"
        [attr.aria-current]="rla.isActive ? 'location' : null"
    >
        {{ tabItem.label }}
    </a>
</ng-template>

<ng-template #disabledNavigationItem let-tabItem="tabItem">
    <span class="sh-tab-navigation__item--disabled">{{ tabItem.label }}</span>
</ng-template>
